const box = (props) => props.children;

export default box;
